import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'shared-hub-header',
  imports: [],
  templateUrl: './hub-header.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HubHeaderComponent {}
